( function ( $ ) {

  const $main = $( '.jobs-main' )
  const $form = $( 'form', $main )
  const debouncedQuery = debounce(query, 300)

  function debounce(func, wait = 300) {
    let timeout
    return function (...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }

  function get_form_data () {
    const data = {}
    $( '.job-field', $form ).each( function () {
      let val
      let $select
      switch ( $(this).data( 'type' ) ) {
        case 'search':
          val = $('input', this).val()
          if ( val ) {
            data.s = val
          }
          break
        case 'term':
          $select = $('select', this)
          val = $select.val()
          if ( val && ( !Array.isArray( val ) || val.length ) ) {
            data.terms = data.terms || {}
            data.terms[ $select.data('tax') ] = val
          }
          break
        case 'select':
          $select = $('select', this)
          val = $select.val()
          if ( val && ( !Array.isArray( val ) || val.length ) ) {
            if ( $select.hasClass( 'is-term' ) ) {
              data.terms = data.terms || {}
              data.terms[ $select.attr('name') ] = val
            } else {
              data[ $select.attr('name') ] = val
            }
          }
          break;
      }
    });
    return data
  }

  let xhr;
  function query ( page = null ) {
    xhr?.abort?.()
    const data = get_form_data()
    if ( page ) {
      data.page = parseInt( page )
    }
    xhr = ThemeJS.Functions.wp_rest_request({
      endpoint: 'jobs/load-page',
      data: data,
      success ( res ) {
        $('.job-results').replaceWith( res.html )
        if ( page ) {
          $( `.page-numbers[aria-current=true]`, $main ).first().focus()
        }
        ThemeJS.Functions.scroll_to( $main, {
          direction: 'up',
        });
      },
      complete () {

      }
    })
  }

  $form.on( 'submit', e => {
    e.preventDefault()
    query()
  })

  $form.on( 'change', 'select', () => query() )

  $form.on('input', '.job-field[data-type="search"] input', function () {
    debouncedQuery()
  })

  $main.on( 'click', 'button.page-numbers', function () {
    query( $(this).data('page') )
  })

  $( 'button.clear-filters', $form ).on( 'click', function () {
    // avoiding triggering actual change event so that we can trigger query only once
    $( 'input', $form ).val( null )
    $( 'select', $form ).val( null ).trigger( 'change.select2' )
    query()
  })
  

  // filter city optgroups by selected province
  const $city_select = $( '#city-select' )
  const $province_select = $( '#province-select' )

  if ( $province_select.length && $city_select.length ) {
    $province_select.on( 'change', function () {
      $city_select.select2('setOgFilter', $province_select.val() )
    })
  }

  // filter salary optgroups by selected job type
  const $salary_select = $( '#salary-select' )
  const $type_select = $( '#term--job-type' )

  if ( $type_select.length && $salary_select.length ) {
    $type_select.on( 'change', function () {
      $salary_select.select2('setOgFilter', $type_select.val() )
    })
  }

  $form.removeClass('hidden');

})( jQuery );